<template>
  <Form
    :class="`form-${block}`"
    @request="activityRepeatSubmit"
    v-model="modelFormData"
  >
    <div
      class="form__inputs"
      :class="`form-${block}__inputs`"
    >
      <AppInputDate title="Дата и время начала"
                    width="338px"
                    name="start_time"
                    type="single"
                    :timer="true"
      />

      <AppInputDate title="Дата и время завершения"
                    width="338px"
                    name="end_time"
                    type="single"
                    :timer="true"
      />
      <AppRadio title="Каждый день"
                name="RepeatPeriod"
                style="margin-bottom: 10px;"
                @toggle-check="setType('every_day')"
      />
      <AppRadio title="Каждую неделю"
                name="RepeatPeriod"
                style="margin-bottom: 10px;"
                @toggle-check="setType('every_week')"
      />
      <!-- <AppRadio title="Каждый месяц"
                name="RepeatPeriod"
                style="margin-bottom: 10px;"
                @toggle-check="setType('every_month')"
      />
      <AppRadio title="Каждый год"
                name="RepeatPeriod"
                @toggle-check="setType('every_year')"
      /> -->
    </div>
    <div
      class="form__buttons"
      :class="`form-${block}__buttons`"
    >
      <AppButton :title="setBtnSubmitText" type="main" />
      <AppButton title="Отмена" type="alt" @click.native.prevent="() => $emit('cancel')" />
    </div>
  </Form>
</template>

<script>
import AppButton from '@/components/page/button/AppButton.vue'
import Form from '@/components/page/Form/Form.vue'
import AppInputDate from '@/components/page/input/AppInputDate'
import AppRadio from '@/components/page/input/AppRadio'
// import axios from '@/utils/axios.js'
// import { config } from '@/store/index'

export default {
  props: {
    block: {
      type: String,
      default: 'modal'
    },
    formData: {
      type: Object,
      default: () => {}
    },
    isEditForm: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'formData',
    event: 'changeFormData'
  },

  data: () => ({
    checkedRepeatPeriod: ''
  }),

  mounted () {
    if (this.formData) {
      console.log(this.formData)
    }
  },

  computed: {
    setBtnSubmitText () {
      return 'Сохранить'
    },

    modelFormData: {
      get () {
        return this.formData
      },
      set (val) {
        this.$emit('changeFormData', val)
      }
    }
  },

  methods: {
    setType (value) {
      this.checkedRepeatPeriod = value
    },
    activityRepeatSubmit (data) {
      data = {
        ...data,
        period_value: this.checkedRepeatPeriod
      }
      this.$emit('activityRepeatSubmit', data)
    }
  },

  components: {
    AppButton,
    Form,
    AppInputDate,
    AppRadio
  }
}
</script>

<style lang="scss" scoped>
.form__inputs {
  margin-bottom: 32px;
  max-width: 340px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.flatpickr-calendar {
  width: 160px;
}

.form-modal {
  width: 360px !important;
  align-items: center;
}
</style>
